exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textareaInput[data-v-20c8b6d2]{height:88px!important}.input-container[data-v-20c8b6d2]{font-size:0;vertical-align:top}.input-container[data-v-20c8b6d2] input{height:100%;line-height:100%;font-size:14px;display:block}.input-container[data-v-20c8b6d2] textarea{height:100%;line-height:1.5;font-size:14px;display:block}.input-container[data-v-20c8b6d2] .el-input{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20c8b6d2","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Input/index.vue
// module id = 589
// module chunks = 0